export default function(can, cannot) {
  // property
  can('view', 'Property');
  cannot('edit', 'Property');
  cannot('add', 'Property');
  can('bulk-edit', 'Property');
  can('list', 'Property');
  can('change-manage-company', 'Property');
  // repair content of property
  can('list', 'PropertyRepairContent');
  cannot('edit', 'PropertyRepairContent');
  can('view', 'PropertyRepairContent');

  // partner
  can('view', 'Partner');
  can('view-detail', 'Partner');
  can('add', 'Partner');
  can('edit', 'Partner');
  can('list', 'Partner');
  can('link', 'Partner');

  // account
  can('view', 'Account');
  can('view-detail', 'Account');
  can('add', 'Account');
  can('edit', 'Account');
  can('list', 'Account');
  can('link', 'Account');

  // repair content
  can('view', 'RepairContent');

  // Dashboard
  can('view', 'Dashboard');

  // Master
  can('view', 'Master');

  // my page
  can('view', 'MyPage');

  // side bar
  can('view-menu', 'Dashboard');
  can('view-menu', 'Master');
  can('view-menu', 'Property');
  can('view-menu', 'Partner');
  can('view-menu', 'Account');
}